import { render, staticRenderFns } from "./CardDeleteAction.vue?vue&type=template&id=8db0c094"
import script from "./CardDeleteAction.vue?vue&type=script&lang=js"
export * from "./CardDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports